export default __webpack_public_path__ + "static/media/business-report.18524fcc.svg";